import withStyles from 'react-jss';

import Header from './component';
import styles from './styles';

export default withStyles(styles)(Header);
